module.exports = __webpack_public_path__ + "static/media/1.2655e9a0.jpg";